export const NEW = "New";
export const OPEN = "Open";
export const PARTIALLY_FINISHED = "Partially Finished";
export const FINISHED = "Finished";
export const CLOSED = "Closed";

export const STATUS_BUTTON = "statusButton";
export const ORIGIN_BUTTON = "originButton";
export const TYPE_BUTTON = "typeButton";
export const TIMESHEET_STATUS_BUTTON = "timesheetStatusButton";
